import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field, propTypes as reduxFormPropTypes } from 'redux-form';
import { FormattedMessage } from 'react-intl';
import getValidators from '@chama/utils/functions/validators';
import RFTextField from '../ReduxFormTextField';
import RFDropdown from '../ReduxFormDropdown';
import Spinner from '../Spinner';
import Modal from '../Modal';
import './index.css';

const propTypes = {
  ...reduxFormPropTypes,
  formatMessage: PropTypes.func.isRequired,
  handleRef: PropTypes.func.isRequired,
  onProductAdd: PropTypes.func.isRequired,
  refName: PropTypes.string.isRequired,
  brandList: PropTypes.array.isRequired,
};

const priceField = fieldInfo => (
  <RFTextField
    {...fieldInfo}
    textFieldProps={{
      currency: true,
      name: fieldInfo,
      placeholder: 'R$ XX,XX',
      disabled: fieldInfo.disabled,
    }}
  />
);

/**
 * FIXME: Hiding/closing is done by using refs. Should be either refactored/deprecated at
 * some point, though still being used across many parts of the app.
 */
class AddProductModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
    };
    this.validators = getValidators('pt-BR');
  }

  handleRef = refName => {
    return ref => {
      this[refName] = ref;
    };
  };

  show = () => this.modal.show();

  hide = () => this.modal.hide();

  componentWillMount() {
    const { brandList } = this.props;

    this.createBrandField(brandList);
  }

  componentWillReceiveProps({ brandList }) {
    const hasBrandListChanged =
      brandList && this.props.brandList && brandList.length !== this.props.brandList.length;

    if (hasBrandListChanged) {
      this.createBrandField(brandList);
    }
  }

  createBrandField = brandList => {
    const {
      autofill,
      untouch,
      intl: { formatMessage },
    } = this.props;
    const intoDropdownItems = brand => {
      return {
        value: brand.toUpperCase(),
        primaryText: brand.toUpperCase(),
      };
    };
    const dropdownProps = {
      items: brandList.map(intoDropdownItems),
      placeholder: formatMessage({
        id: 'choose_a_brand',
        defaultMessage: 'Choose a brand',
      }),
    };

    this.setState({
      brandField: fieldInfo => <RFDropdown {...fieldInfo} dropdownProps={dropdownProps} />,
    });

    autofill('brand', null);
    untouch('brand');
  };

  handleProductAdd = fieldValues => {
    const { onProductAdd, untouch } = this.props;

    this.setState({ isLoading: true });

    onProductAdd(fieldValues)
      .then(() => {
        const { change } = this.props;

        this.setState({ isLoading: false });

        change('price', 0);
        untouch('price');
      })
      .catch(() => this.setState({ isLoading: false }));
  };

  renderLoadingSpinner = () => {
    const { isLoading } = this.state;

    if (isLoading) {
      return (
        <div className="AddProductModal__loading_wrapper" key="loading">
          <Spinner fill>
            <FormattedMessage id="saving" defaultMessage="Saving" />
          </Spinner>
        </div>
      );
    }

    return null;
  };

  render() {
    const { formatMessage, handleSubmit } = this.props;
    const { isLoading, brandField } = this.state;

    return (
      <Modal
        ref={this.handleRef('modal')}
        title={formatMessage({
          id: 'add_product_title',
          defaultMessage: 'Add new product',
        })}
        cancelButtonText={formatMessage({
          id: 'general.cancel',
          defaultMessage: 'Cancel',
        })}
        confirmButtonText={formatMessage({
          id: 'add_product',
          defaultMessage: 'Add new product',
        })}
        hideOnConfirm={false}
        onConfirm={handleSubmit(this.handleProductAdd)}
        isLoading={isLoading}
      >
        <form onSubmit={handleSubmit(this.handleProductAdd)}>
          <div className="AddProductModal__input_wrapper">
            <div className="AddProductModal__label">
              <FormattedMessage id="brand" defaultMessage="Brand" />
            </div>
            <div className="AddProductModal__input--dropdown">
              <Field name="brand" component={brandField} validate={this.validators.required} />
            </div>
          </div>
          <div className="AddProductModal__input_wrapper">
            <div className="AddProductModal__label">
              <FormattedMessage id="price" defaultMessage="Price" />
            </div>
            <div className="AddProductModal__input--text_field">
              <Field name="price" component={priceField} validate={this.validators.cylinderPrice} />
            </div>
          </div>
        </form>
      </Modal>
    );
  }
}

AddProductModal.propTypes = propTypes;

export default AddProductModal;



// WEBPACK FOOTER //
// ../ui-components/components/AddProductModal/index.jsx